import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import { useViewContext } from "../ViewProvider";

export function ViewSelect() {
  const { t } = useTranslation();
  const { visibleViews, selectedView, setSelectedView } = useViewContext();

  return (
    <Autocomplete
      size="small"
      sx={{ width: "100%" }}
      options={visibleViews}
      value={selectedView}
      onChange={(_, v) => setSelectedView(v)}
      getOptionLabel={o => o.name}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      renderInput={params => (
        <TextField
          {...params}
          label={t("views.select.label")}
          placeholder={t("views.select.placeholder")}
        />
      )}
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          {option.name}
        </li>
      )}
    />
  );
}
